import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';

import FormField from 'containers/FormField';
import LikertField from 'components/LikertField';

import FormProvider from 'routes/Documents/containers/FormProvider';
import InfoField from 'routes/Documents/components/InfoField';

import { msisSection, msisWrapper, padded, oddSection, evenSection } from './Scores.less';

import FSMCSections from '../FSMCSections';
import { nowPartialDate } from 'neuro-utils';

const FSMCForm = props => {
  // Effect to set 'date' field as current date in partial form when creating a new FSMC form
  React.useEffect(() => {
    if (!props.formValues.date && props.editing && Object.keys(props.initialValues).length === 0) {
      props.change('date', nowPartialDate());
    }
  }, []);

  return (
    <FormProvider {...props}>
      <InfoField>
        <Grid fluid>
          <Row className={padded}>
            <Col xs>
              <h6>
                <FormattedMessage id="fsmc.instructions.part1" />
              </h6>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <h6>
                <FormattedMessage id="fsmc.instructions.part2" />
              </h6>
            </Col>
          </Row>
        </Grid>
      </InfoField>
      <div className={msisWrapper}>
        {FSMCSections.map((fsmc, i) => (
          <div key={`fsmc_${fsmc}`} className={i % 2 === 0 ? oddSection : evenSection}>
            <Grid fluid className={msisSection}>
              <Row middle="xs">
                <Col xs={5}>
                  <h6>
                    <FormattedMessage id={`fsmc.section.${fsmc}`} />
                  </h6>
                </Col>
                <Col xs={7}>
                  <FormField
                    name={fsmc}
                    component={LikertField}
                    max={5}
                    minLabel="fsmc.label.notAtAll"
                    maxLabel="fsmc.label.completely"
                    startFromZero={false}
                    invertedScale={false}
                    allLabels={[
                      'fsmc.label.notAtAll',
                      'fsmc.label.notMuch',
                      'fsmc.label.slightly',
                      'fsmc.label.aLot',
                      'fsmc.label.completely',
                    ]}
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        ))}
      </div>
    </FormProvider>
  );
};

export default FSMCForm;
